import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedAuthorizationService } from '@app/shared/services/shared-authorization.service';
import { ICoreAuthorizationDTO } from '@core/model';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationPACService extends SharedAuthorizationService {
  constructor(http: HttpClient, shellService: ShellService) {
    super(http, shellService, ProductNames.PACIM);
  }

  getCoreAuthorization(
    tenantId: string,
    authorizationByProductId: string
  ): Observable<ICoreAuthorizationDTO> {
    return this.getAuthorization(tenantId, authorizationByProductId).pipe(
      map((x: object) => this.mapAuthorizationDTO(x))
    );
  }

  mapAuthorizationDTO(authorizationDto: object): ICoreAuthorizationDTO {
    const auth = authorizationDto['authorizationProduct'];
    return {
      authorizationId: auth['authorizationByProductId'],
      authorizationNumber: auth['authorizationNumber'],
      authorizationStatus: auth['authorizationStatus']['description'],
      createdBy: auth['createdBy'],
      createdOn: auth['createdDate'],
      effectiveFromDate: auth['effectiveStartDate'],
      effectiveToDate: auth['effectiveEndDate'],
      productId: auth['productId'],
      streamData: { facilityType: authorizationDto['facilityType']['description'], productName: auth['productName'], outOfNetworkOverride: authorizationDto['outOfNetworkOverride'] },
      urgency: authorizationDto['urgency']['description'],
    };
  }
}
